const Vr1 = () => {

    return (
      <div style={{ width: "100%", height: "100vh" }}>
        <iframe
          src={`https://hitimperial.github.io/VR360-19pateras/PNG%20n.2/3d%2019-2w/publish%2019-2w/index.htm`}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          allowFullScreen
          title="VR 19n Level 2 Tour"
        ></iframe>
      </div>
    );
};

export default Vr1;
